import { Log as OidcLog, WebStorageStateStore } from 'oidc-client-ts';
import {
  env,
  registerLayoutComponents,
  setupApi,
  setupApiV4,
  setupI18n,
  setupOAuth,
  setupRaygun,
  registerDashboardLayoutComponents,
} from '@diana/core';
import { routeUrls } from './app/Routing/RouteUrls';
import { resources } from './i18n';
import { lazy } from 'react';

const host = window.location.origin;

const apiV4Fallback = env('DIANA_API_ENDPOINT');
const configApiV4 = env('DIANA_API_V4_ENDPOINT') || env('DIANA_API_V4_CONFIG');
const workApiV4 = env('DIANA_API_V4_WORK');
const attachmentApiV4 = env('DIANA_API_V4_ATTACHMENTS');

setupRaygun({ apiKey: env('RAYGUN_KEY'), version: env('APP_VERSION') });
setupApi({ baseURL: env('DIANA_API_ENDPOINT') });
setupApiV4('config', { baseURL: configApiV4 || apiV4Fallback });
setupApiV4('work', { baseURL: workApiV4 || apiV4Fallback });
setupApiV4('attachment', { baseURL: attachmentApiV4 || apiV4Fallback });
setupI18n({ resources });
setupOAuth({
  authority: env('DIANA_SEC_ENDPOINT'),
  automaticSilentRenew: true,
  redirect_uri: `${host}${routeUrls.signIn.path}`,
  client_id: env('OAUTH_CLIENT_ID'),
  client_secret: env('OAUTH_SECRET'),
  response_type: 'code',
  scope: 'openid email profile diana-api',
  silentRequestTimeoutInSeconds: 60,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

const logLevel: OidcLog =
  (localStorage.getItem('feature.oidcLogLevel') as unknown as OidcLog) ?? OidcLog.ERROR;

console.log('[OIDC] Log level:', logLevel);
// Log OIDC client errors
OidcLog.setLevel(logLevel);
OidcLog.setLogger(console);

registerLayoutComponents(() => {
  return {
    'adp-massflowmeter': lazy(
      () => import('./components/External/AdpMassFlowMeter/AdpMassFlowMeter'),
    ),
    'adp-bargeaudithistory': lazy(
      () => import('./components/External/AdpBargeAuditHistory/AdpBargeAuditHistory'),
    ),
    'adp-qualityanalysis': lazy(
      () => import('./components/External/AdpQualityAnalysis/AdpQualityAnalysis'),
    ),
    'adp-labresults': lazy(() => import('./components/External/AdpLabResults/AdpLabResults')),
    timelineV3: lazy(() => import('./components/External/LupaTimelineUI/TimelineLC')),
    'timeline-backend': lazy(() => import('./components/External/LupaTimeline/TimelineLC')),
    'o3o-vessel-survey-measurements': lazy(
      () =>
        import('./components/External/O3oVesselSurveyMeasurements/O3oVesselSurveyMeasurementsLC'),
    ),
  };
});

registerDashboardLayoutComponents(() => {
  return {
    'pinned-dashboards': lazy(() => import('./components/PinnedDashboards/PinnedDashboards')),
  };
});
